import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=6d8b9e35&scoped=true&"
import script from "./dashboard.vue?vue&type=script&lang=js&"
export * from "./dashboard.vue?vue&type=script&lang=js&"
import style0 from "./dashboard.vue?vue&type=style&index=0&id=6d8b9e35&prod&lang=scss&"
import style1 from "@/assets/css/style.css?vue&type=style&index=1&id=6d8b9e35&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8b9e35",
  null
  
)

export default component.exports